module.exports = __webpack_public_path__ + "img/br16.8676cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br16.jpg
// module id = 3MgB
// module chunks = 0